<ui-table
  [gridData]="gridData()"
  [gridColumns]="gridColumns()"
  [isLoading]="(loaderService.isActive() | async) || false"
  [isReorderable]="true"
  [isResizable]="true"
  [state]="gridState"
  [labels]="translate.tableLabels()()"
  [rowPrimaryKey]="rowPrimaryKey"
  (selectionChange)="selectRow($any($event))"
  (columnResizeChange)="columnResize($any($event))"
  (columnReorderChange)="columnReorder($any($event))"
  (stateChange)="onTableStateChange($event)"
  (selectionSummaryChange)="selectionSummaryChange($event)"
  (selectAllAllowedChange)="selectAllAllowedChange($event)"
  id="{{ parentId }}-listing-table"
  [selectionMode]="tableSelectionMode"
/>
<aos-side-panel
  [isDisabled]="isSidePanelDisabled"
  [basicData]="selectedRowBasicData()"
  [componentBody]="sidePanelBodyComponent"
  [deviceCardData]="deviceDetails$ | async"
  [customerCardData]="customerDetails$ | async"
  [componentTitle]="sidePanelTitleComponent"
  [titleData]="titleComponentData"
  [title]="sidePanelTitle!"
  [toggle]="isSidePanelOpened()"
  (toggleChange)="resetSelectedRow()"
/>
